module.exports = __webpack_public_path__ + "img/pay-tm-logo.22638eb.jpg";